<template>
	<div>
		<SpeakerNotesPanel :content-id="id" :view="view" />
	</div>
</template>

<script>
import SpeakerNotesPanel from '@/components/lessonPlan/components/slides/notes/SpeakerNotesPanel.vue';

export default {
  name: "SpeakerNotes",
  props: ["id", "view"],
  components: { SpeakerNotesPanel }
}
</script>
